import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IUpdatedDateRange, NtCompany } from '../../models/nt-company';
import { FinancialYear } from '../../models/financial-years';
import { IKeyValue } from '../../models/group-edit-config';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { CompanyService } from '../../../../services/company.service';

@Component({
  selector: 'app-tabbed-company-view',
  templateUrl: './tabbed-company-view.component.html',
  styleUrls: ['./tabbed-company-view.component.scss']
})
export class TabbedCompanyViewComponent implements OnInit, OnDestroy {
    //Company container params
    @Input() useContainer = false;
    @Input() showTabBar = true;

    @Input() useDropdownMode = false;
    @Input() dateFilterBasicMode = false;

    @Output() companyAvailable = new EventEmitter<NtCompany>();

    @Input() title = '';
    @Input() description = '';
    @Input() noTabsText = '';
    //Date selector parameters
   //@Input() years: FinancialYear[] = [];
    //@Input() selectedYear: FinancialYear;
    dateRange: IUpdatedDateRange;
    // @Input('dateRange') set dateRangeInput(newDate: IUpdatedDateRange)  {
    //     if(!newDate){
    //         console.log("Requested date range object is not valid");
    //         return;
    //     }

    //     if(this.dateRange){
    //         if(this.dateRange.startDate === newDate.startDate && this.dateRange.endDate === newDate.endDate){
    //             console.log("Requested date range the same as current values");
    //             return;
    //         }
    //     }

    //     this.dateRange = newDate;
    // }

    region = '';
    @Output() selectedDateRange = new EventEmitter<IUpdatedDateRange>();

    //Tab item params
    tabItems: IKeyValue[] = [];
    @Input('tabItems') set tabItemsSetter(tabs: IKeyValue[]){
        this.tabItems = tabs;
        this.setSelectedTab();
    }
    selectedItem: IKeyValue;
    updatedSelectedItem: IKeyValue;

    routeId: '';

    //Group Header inputs
    @Input() pageSize;
    @Input() itemCount;
    @Input() optionalDisplayColumns = [];
    @Input() currentPageIndex = 0;
    @Input() pageSizeOptions: number[] = [];
    @Input() selectedIds: number[] = [];
    @Input() enableSearch = true;
    @Input() enableSettings = true;
    @Input() enableBatch = true;
    @Input() enableTitle = true;
    @Input() batchMode = 'assets';
    @Input() enableDateFilter = true;
    @Input() showCommonHeader = true;
    
    @Output() updatePageSize = new EventEmitter<number>();
    @Output() searchExecute = new EventEmitter<string>();
    @Output() searchClear = new EventEmitter<boolean>();
    @Output() updatePage = new EventEmitter<number>();
    @Output() setupDisplayColumns = new EventEmitter<boolean>();
    @Output() batchEditCommand = new EventEmitter<string>(); 

    showSelect = false;
    sub = new Subject();

    constructor(private route: ActivatedRoute,
        private router: Router,
        private comp: CompanyService
    ) { }

    ngOnInit(): void {
        this.route.paramMap
            .pipe(takeUntil(this.sub))
            .subscribe((route: any) => {
                const id = route.params['id'];
                this.routeId = id;
                this.setSelectedTab();
            });

        this.comp.SelectedDateRange.pipe(takeUntil(this.sub))
            .subscribe(range => {
                if(range){
                    this.dateRange = range;
                }
                
            });
    }

    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete();
    }

    updateTab(){
        const newUrk = this.router.url.replace(this.selectedItem.key, this.updatedSelectedItem.key);
        this.router.navigateByUrl(newUrk);
    }

    setSelectedTab(){
        const tabItem = this.tabItems.find(x=>x.key === this.routeId);
        if(tabItem){
            this.selectedItem = tabItem;
            this.updatedSelectedItem = tabItem;
        }
    }

    companyAvailableHandler(c: NtCompany){
        this.region = c.region;
        this.companyAvailable.emit(c);
    }

    selectedDateRangeHandler(v: IUpdatedDateRange){
        this.showSelect = false;
    }

    updatePageSizeHandler(size: number){
        console.log("TabbedCompanyview pageSizeChanged notification received from child", size);
        this.updatePageSize.emit(size);
    }

    searchHandler(term: string){
        this.searchExecute.emit(term);
    }

    clearSearchHandler(){
        this.searchClear.emit(true);
    }

    updatePageHandler(index: number){
        this.updatePage.emit(index);
    }

    setupDisplayColumnsHandler(){
        this.setupDisplayColumns.emit(true);
    }

    batchEditCommandHandler(command: string){
        this.batchEditCommand.emit(command);
    }


}
